import React, { Component } from 'react';

class PopularList extends Component {
  constructor(props) {
    super(props);

  }

  render() {
    const { object = {} } = this.props;

    return (
      <ul>
        {Object.keys(object).map((key) =>
          (object[key].title != null &&
            <li className="popular-item" key={key}>
              <a href={object[key].link} tabIndex='-1'>{object[key].title}</a>
            </li>
          )
        )}
      </ul>
    )
  }
}

export default PopularList;



// WEBPACK FOOTER //
// ./src/PopularList.js